import { Link } from "react-router-dom";
import { CalendarHeart, MessageCircle } from "lucide-react";
import { BRAND } from "../lib/data";

export default function FloatingButtons() {
  return (
    <div className="fixed right-5 bottom-5 z-40 flex flex-col gap-3">
      <a
        data-testid="floating-whatsapp"
        href={`https://wa.me/${BRAND.phoneIntl}?text=Hi%20Enrich%20Hair%20%26%20Beauty%2C%20I%27d%20like%20to%20book%20an%20appointment.`}
        target="_blank"
        rel="noreferrer"
        className="pulse-gold w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-105 transition-transform"
        aria-label="WhatsApp"
      >
        <MessageCircle size={22} />
      </a>
      <Link
        to="/booking"
        data-testid="floating-book"
        className="w-14 h-14 rounded-full bg-[#C9A34E] text-[#0B0B0B] flex items-center justify-center shadow-xl hover:scale-105 transition-transform"
        aria-label="Book Now"
      >
        <CalendarHeart size={22} />
      </Link>
    </div>
  );
}
